import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useDeleteMusterPointById } from "../../../hooks/common/mutation";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteMusterPointModalProps {
  musterPointId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteMusterPointModal = ({
  musterPointId,
  isOpen,
  onOpenChange,
}: DeleteMusterPointModalProps) => {
  const {
    mutateAsync: DeleteMusterPointById,
    isPending: isDeleteMusterPointByIdLoading,
  } = useDeleteMusterPointById();

  const { t } = useTranslation();

  const handleDeleteMusterPoint = useCallback(async () => {
    try {
      const body = {
        encryptedId: musterPointId.toString(),
      };

      await DeleteMusterPointById(body);
      toast.success(t("musterPointDeleted"));
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_APPOINTMENT) {
        // toast.error(t("buildingNotDeletedUsedByAppointment"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [musterPointId, DeleteMusterPointById, t, onOpenChange]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteMusterPoint")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteMusterPoint}
            isLoading={isDeleteMusterPointByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteMusterPointModal);
